module.exports = {"TXTCLI_Game_Information":{"id":"TXTCLI_Game_Information","defaultMessage":"Informations sur les jeux"}}